import Index from '@/views/buyer/contact/Index.vue';
import List from '@/views/buyer/contact/List.vue';
import Chat from '@/views/buyer/contact/Chat.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'contact',
    redirect: { name: 'buyer-contact-list' },
    component: Index,
    children: [
      {
        name: 'buyer-contact-list',
        path: '',
        component: List,
        meta: {
          title: 'お問い合わせ一覧',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
      {
        name: 'buyer-contact-chat',
        path: ':id',
        component: Chat,
        meta: {
          title: 'お問い合わせ詳細',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
